// extracted by css-extract-rspack-plugin
export default {"divider":"divider-ZXnaIn","sm":"sm-B6I69q","lg":"lg-YGm5z7"};